import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { GymDepartmentModel } from "./gym-department.model";

export class GymDepartmentResponse extends GlobalResponseObject {
    data?: GymDepartmentModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GymDepartmentModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}